import './index.css'
import cn from 'clsx'
import React from 'react'
type Props = {
  lines?: number
  type?: 'block' | 'inline'
  gradient?: boolean
}

/**
 * A skeleton loading component that displays placeholder content while data is loading
 * @param lines - The number of skeleton lines to display (defaults to 1)
 * @param type - The display type of the skeleton ('inline' or 'block', defaults to 'inline')
 * @param gradient - Whether to show a gradient animation effect
 * @returns An array of skeleton placeholder elements
 */
const Skeleton = ({ lines, type = 'inline', gradient }: Props) => {
  const textLines = []
  const count = lines || 1

  for (let i = 0; i < count; i++) {
    const className = cn('Skeleton', {
      'Skeleton--line': lines === 1 || (lines && lines > 1 && i < lines - 1),
      'Skeleton--last': lines && lines > 1 && i === lines - 1,
      'Skeleton--inline': type === 'inline',
      'Skeleton--block': type === 'block',
      'Skeleton--gradient': gradient,
    })
    textLines.push(<div key={i} className={className} />)
  }

  return textLines
}

export default React.memo<Props>(Skeleton)
